document.addEventListener('DOMContentLoaded', () => {

    const slider =
        document.querySelector('.videos__track');

    const prev =
        document.querySelector('.videos__nav--prev');

    const next =
        document.querySelector('.videos__nav--next');

    if (!slider || !prev || !next) return;

    function getScrollAmount() {

        const card =
            slider.querySelector('.videos__card');

        if (!card) return 300;

        const gap = 30;

        return card.offsetWidth + gap;
    }

    prev.addEventListener(
        'click',
        () => {

            slider.scrollBy({

                left: -getScrollAmount(),

                behavior: 'smooth'
            });
        }
    );

    next.addEventListener(
        'click',
        () => {

            slider.scrollBy({

                left: getScrollAmount(),

                behavior: 'smooth'
            });
        }
    );

});